import { render } from "./ListOrdered.vue?vue&type=template&id=20d9afa4"
import script from "./ListOrdered.vue?vue&type=script&lang=js"
export * from "./ListOrdered.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__